<template>
	<div
		class="background-banner bg-secondary-700 smm:bg-secondary-800 absolute top-0 left-0 w-full h-full -z-10 overflow-hidden"
		:class="props.classContainer"
	>
		<div class="absolute top-1/2 smm:top-auto smm:bottom-1/2 left-3/4 smm:left-0">
			<div class="relative w-80 h-[450px]">
				<div class="circle-blur rounded-full absolute bottom-0 left-0 w-full h-full scale-75 smm:scale-100" />
			</div>
		</div>
		<div class="absolute bottom-1/2 smm:bottom-auto smm:top-auto right-3/4 smm:right-0">
			<div class="relative w-80 h-[450px]">
				<div
					class="circle-blur rounded-full absolute top-20 smm:top-1/4 smm:right-0 w-full h-full scale-75 smm:scale-100"
				/>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
defineOptions({
	name: 'BackgroundBanner',
})

interface Props {
	classContainer?: string
}

const props = withDefaults(defineProps<Props>(), {
	classContainer: 'rounded-lg sm:rounded-3xl',
})
</script>
<style lang="postcss">
.background-banner {
	.circle-blur {
		@apply opacity-30 bg-primary-600;
		filter: blur(123px);
	}
}
</style>
